import { useCallback, useState } from 'react';
import { chartOption } from '../utils';
import { useMetricSeries } from './useMetricSeries';

function useToolbox({ metric }) {
  const [instance, setInstance] = useState(null);
  const metricChartOption = chartOption(metric);

  // chart instance with init option
  const chartInstanceRefCb: any = useCallback(
    (instance) => {
      setInstance(instance);
      instance.setOption(metricChartOption);
    },
    [metricChartOption],
  );

  const data = useMetricSeries({
    metric, // for unit toggle
    instance,
  });

  return {
    chartInstanceRefCb,
    instance,
    data,
  };
}

export default useToolbox;
